<template>
  <layout-workflow>
    <template #subheader>
      <v-row>
        <v-col class="ml-4 mr-4">
          <span class="grey--text pa-2"
            >Showing {{ totalHits }} Patients for "{{ searchString }}"</span
          >
        </v-col>
      </v-row>
    </template>
    <v-row>
      <v-col>
        <div class="ml-4 mr-4">
          <patient-search-table
            :results="results"
            :loading="loading"
            :page-number="pageNumber"
            :items-per-page="itemsPerPage"
            :sort-field="sortField"
            :sort-direction="sortDirection"
            @pagination="pagination"
          />
        </div>
      </v-col>
    </v-row>
  </layout-workflow>
</template>

<script>
import LayoutWorkflow from '@/components/layout/LayoutWorkflow'
import PatientSearchTable from '@/components/search/PatientSearchTable'
import { patientSearchService } from '@/services/patient-search-service'
import { mapState } from 'vuex'
import _ from 'lodash'

export default {
  components: {
    LayoutWorkflow,
    PatientSearchTable
  },
  props: {
    searchString: { type: String, default: null },
    pageNumber: { type: Number, default: 0 },
    itemsPerPage: { type: Number, default: 15 },
    sortField: { type: String, default: '_score' },
    sortDirection: { type: String, default: 'desc' },
    orgId: { type: String, required: true }
  },
  data() {
    return {
      results: {},
      loading: false,
      totalHits: 0
    }
  },
  computed: {
    ...mapState({
      refreshPatientSearch: state => state.refreshPatientSearch
    })
  },
  watch: {
    refreshPatientSearch() {
      this.$router.replace({
        name: 'patient-search-list',
        params: { orgId: this.orgId },
        query: {
          searchString: this.refreshPatientSearch,
          pageNumber: 1,
          itemsPerPage: 10
        }
      })
      this.searchChanged({
        searchString: this.refreshPatientSearch,
        pageSize: 10,
        pageNumber: 1,
        sortField: '_score',
        sortDirection: 'asc'
      })
    }
  },
  methods: {
    async searchChanged(params) {
      if (!_.isEmpty(params.searchString)) {
        this.loading = true
        const response = await patientSearchService.search(this.orgId, params)
        this.totalHits = response.data.totalHits
        this.results = response.data
      } else {
        this.results = {}
      }
      this.loading = false
    },
    pagination(options) {
      this.$router.replace({
        name: 'patient-search-list',
        params: { orgId: this.orgId },
        query: {
          searchString: this.searchString,
          pageNumber: options.page,
          itemsPerPage: options.itemsPerPage,
          sortField: options.sortBy[0] || '_score',
          sortDirection: options.sortDesc[0] ? 'desc' : 'asc'
        }
      })
      this.searchChanged({
        searchString: this.searchString,
        pageSize: options.itemsPerPage,
        pageNumber: options.page - 1,
        sortField: options.sortBy[0] || '_score',
        sortDirection: options.sortDesc[0] ? 'desc' : 'asc'
      })
    }
  }
}
</script>
